import {Component, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {SupportDialogComponent} from "../../dialogs/support-dialog/support-dialog.component";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  showSupportDialog() {
    this.dialog.open(SupportDialogComponent);
  }
}
